import React from 'react'
import { ListItem,
  ListItemText,
  Paper,
  Grid,
  Button
} from "@material-ui/core";

export default function CostCentreEntry({resource: costCentre, onEdit, user}) {

  return (
    <Paper style={{ margin: 16 }}>
      <ListItem>
        <Grid container>
          <Grid xs={6} md={6} item style={{ paddingRight: 16 }}>
            <ListItemText primary={costCentre.name} />
          </Grid>
          <Grid xs={4} md={4} item style={{ paddingRight: 16 }}>
            <ListItemText primary={`£${costCentre.threshold || '-'}`} />
          </Grid>
          <Grid xs={2} md={2} item>
          { user.type === 'admin' && <Button
              color="primary"
              variant="outlined"
              onClick={() => onEdit(costCentre)}
              fullWidth
            >Edit</Button> }
          </Grid>
        </Grid>
        {/* <ListItemSecondaryAction>
          <Button
            color="primary"
            onClick={event => handleDeletePurchaseOrder(event, idx)}>
            Delete
          </Button>
        </ListItemSecondaryAction> */}
      </ListItem>
    </Paper>
  )
}
